import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=979cdd6e&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=ts"
export * from "./TaskItem.vue?vue&type=script&lang=ts"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=979cdd6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979cdd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979cdd6e')) {
      api.createRecord('979cdd6e', component.options)
    } else {
      api.reload('979cdd6e', component.options)
    }
    module.hot.accept("./TaskItem.vue?vue&type=template&id=979cdd6e&scoped=true", function () {
      api.rerender('979cdd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskItem.vue"
export default component.exports